import { render, staticRenderFns } from "./iconList.vue?vue&type=template&id=48820e2b&scoped=true"
import script from "./iconList.vue?vue&type=script&lang=js"
export * from "./iconList.vue?vue&type=script&lang=js"
import style0 from "./iconList.vue?vue&type=style&index=0&id=48820e2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48820e2b",
  null
  
)

export default component.exports